import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Color } from "../colors/colors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DEFAULT_OPTIONS = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      labels: {
        font: {
          color: Color.darkBlue,
        },
        color: Color.darkBlue,
        usePointStyle: true,
        pointStyle: "rectRounded",
      },
    },
  },
};

const CustomBar = ({ data = { labels: [], datasets: [] }, options = {} }) => {
  return <Bar options={{ ...DEFAULT_OPTIONS, ...options }} data={data} />;
};

export default CustomBar;
